import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const ItelReceivedTaskAttemptSchema = z.object({
  type: z.literal(TaskType.ITEL_RECEIVED),
  fileIds: z.array(z.string()),
});
